import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa';
import './CustomDropdown.css';

const CustomDropdown = ({ options, selected, onSelect, label, image }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleSelect = (option) => {
    onSelect(option);
    setShowDropdown(false);
  };

  return (
    <div className="custom-dropdown w-100">
      {/* <label>{label}</label> */}
      <Dropdown show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
        <Dropdown.Toggle className="w-100 d-flex justify-content-between align-items-center filter">
          <div className="d-flex align-items-center overflow-hidden">
            <img
              src={selected?.image || image}
              alt="Dropdown Icon"
              className="dropdown-image"
            />
            <span className="ms-2">{selected ? `${label}: ${selected.label}` : `${label} - All`}</span>
          </div>
          <FaChevronDown className="dropdown-arrow" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="w-100">
          {options.map((option, idx) => (
            <Dropdown.Item key={idx} onClick={() => handleSelect(option)}>
              <div className="d-flex align-items-center">
                {option.image && (
                  <img src={option.image} alt={option.label} className="dropdown-image me-2" />
                )}
                <span>{option.label}</span>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default CustomDropdown;
